(function () {
  'use strict';

  if (window.__tdFundaColorGalleryLoaded) return;
  window.__tdFundaColorGalleryLoaded = true;

 var PRODUCT_HANDLE = 'fundacubre-sofa-the-dogs';
 var EXTRA_PRODUCT_ID = '10427727118636';

function isSupportedProductRoot(root) {
  if (!root) return false;

  return (
    root.dataset.productHandle === PRODUCT_HANDLE ||
    String(root.dataset.productId || '') === EXTRA_PRODUCT_ID
  );
}
var INITIAL_DEFAULT_GALLERY = 'td-initial-default-gallery';
var COLOR_TOKEN = /\[(?:td-color|td-fm-color)\s*[:=]\s*([^\]]+)\]\s*/i;

  function normalizeColor(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function extractMediaId(value) {
    var matches = String(value || '').match(/\d+/g);
    return matches && matches.length ? matches[matches.length - 1] : '';
  }

  function readAndCleanToken(container) {
    if (!container) return '';

    if (container.dataset.tdFundaColor) {
      return container.dataset.tdFundaColor;
    }

    var images = Array.from(
      container.querySelectorAll('img[alt]')
    );

    var color = '';

    images.forEach(function (image) {
      var alt = image.getAttribute('alt') || '';
      var match = alt.match(COLOR_TOKEN);

      if (!match) return;

      if (!color) {
        color = normalizeColor(match[1]);
      }

      image.setAttribute(
        'alt',
        alt.replace(COLOR_TOKEN, '').trim()
      );
    });

    if (color) {
      container.dataset.tdFundaColor = color;
    }

    return color;
  }

function hydrateImages(container) {
  if (!container) return;

  Array.from(
    container.querySelectorAll(
      '[data-td-funda-srcset], [data-td-funda-src]'
    )
  ).forEach(function (image) {
    var deferredSrcset = image.getAttribute(
      'data-td-funda-srcset'
    );

    var deferredSrc = image.getAttribute(
      'data-td-funda-src'
    );

    /*
     * Se restaura primero srcset para que el navegador
     * elija directamente el tamaño adecuado.
     */
    if (deferredSrcset) {
      image.setAttribute('srcset', deferredSrcset);
      image.removeAttribute('data-td-funda-srcset');
    }

    if (deferredSrc) {
      image.setAttribute('src', deferredSrc);
      image.removeAttribute('data-td-funda-src');
    }

    image.removeAttribute(
      'data-td-funda-network-deferred'
    );
  });
}

function setVisible(element, visible) {
  if (!element) return;

  /*
   * La imagen se descarga solamente justo antes
   * de convertirse en visible.
   */
  if (visible) {
    hydrateImages(element);
  }

  element.hidden = !visible;
  element.style.display = visible ? '' : 'none';
  element.setAttribute(
    'aria-hidden',
    String(!visible)
  );
}

  function getSection(sectionId) {
    return document.getElementById(
      'MainProduct-' + sectionId
    );
  }
function getDefaultGalleryMediaIds(sectionId) {
  var configElement = document.getElementById(
    'VariantMediaConfig-' + sectionId
  );

  if (!configElement) return new Set();

  try {
    var config = JSON.parse(configElement.textContent);
    var mediaGroups = config.mediaGroups || {};

    return new Set(
      Object.keys(mediaGroups).filter(function (mediaId) {
        return String(mediaGroups[mediaId]) === 'shared';
      })
    );
  } catch (error) {
    console.warn(
      '[TD Funda Gallery] Error leyendo la galería original',
      error
    );

    return new Set();
  }
}
  function getBuilder(sectionId) {
    var section = getSection(sectionId);

    return section
      ? section.querySelector('[data-td-funda-builder]')
      : null;
  }

function isCorrectProduct(sectionId) {
  return isSupportedProductRoot(
    getBuilder(sectionId)
  );
}

  function indexMedia(gallery) {
    var groupsByMediaId = new Map();

    var slides = Array.from(
      gallery.querySelectorAll(
        '.product__media-item[data-media-id]'
      )
    );

    var thumbs = Array.from(
      gallery.querySelectorAll(
        '.thumbnail-list__item[data-target]'
      )
    );

    slides.forEach(function (slide) {
      var mediaId = extractMediaId(
        slide.dataset.mediaId
      );

      var color = readAndCleanToken(slide);

      if (mediaId && color) {
        groupsByMediaId.set(mediaId, color);
      }
    });

    thumbs.forEach(function (thumb) {
      var mediaId = extractMediaId(
        thumb.dataset.target
      );

      var ownColor = readAndCleanToken(thumb);

      var color =
        groupsByMediaId.get(mediaId) ||
        ownColor;

      if (mediaId && color) {
        groupsByMediaId.set(mediaId, color);
      }

      if (color) {
        thumb.dataset.tdFundaColor = color;
      }
    });

    return {
      groupsByMediaId: groupsByMediaId,
      slides: slides,
      thumbs: thumbs
    };
  }

  function refreshSliders(gallery, visibleCount) {
    var viewer = gallery.querySelector(
      'slider-component[id^="GalleryViewer-"]'
    );

    var thumbnails = gallery.querySelector(
      'slider-component[id^="GalleryThumbnails-"]'
    );

    [viewer, thumbnails].forEach(function (slider) {
      if (!slider) return;

      if (typeof slider.resetPages === 'function') {
        slider.resetPages();
      } else if (
        typeof slider.initPages === 'function'
      ) {
        slider.initPages();
      }

      if (slider.slider) {
        slider.slider.scrollLeft = 0;
      }
    });

    var currentCounter = gallery.querySelector(
      '.slider-counter--current'
    );

    var totalCounter = gallery.querySelector(
      '.slider-counter--total'
    );

    if (currentCounter) {
      currentCounter.textContent = '1';
    }

    if (totalCounter) {
      totalCounter.textContent = String(
        visibleCount
      );
    }

    if (
      typeof gallery.scheduleDesktopViewerNavigationSync ===
      'function'
    ) {
      gallery.scheduleDesktopViewerNavigationSync();
    }
  }
function filterModal(
  sectionId,
  groupsByMediaId,
  selectedColor
) {
  var modal = document.getElementById(
    'ProductModal-' + sectionId
  );

  if (!modal) return;

  var useDefaultGallery =
    selectedColor === INITIAL_DEFAULT_GALLERY;

  var defaultMediaIds =
    getDefaultGalleryMediaIds(sectionId);

  var items = Array.from(
    modal.querySelectorAll(
      '.product-media-modal__content > ' +
      '[data-media-id][data-td-offer-media="solo"]'
    )
  );

  items.forEach(function (item) {
    var mediaId = extractMediaId(item.dataset.mediaId);
    var ownColor = readAndCleanToken(item);
    var group =
      groupsByMediaId.get(mediaId) || ownColor || '';

    var visible;

    if (useDefaultGallery) {
      visible =
        !group &&
        defaultMediaIds.has(String(mediaId));
    } else {
      visible =
        group === selectedColor ||
        group === 'shared';
    }

    setVisible(item, visible);
  });

  if (typeof modal.refreshMedia === 'function') {
    modal.refreshMedia();
  }
}
  function applyColor(
  sectionId,
  color,
  productHandle
) {
  var selectedColor = normalizeColor(color);

  if (
    !selectedColor ||
    !isCorrectProduct(sectionId, productHandle)
  ) {
    return;
  }

  var section = getSection(sectionId);

  var gallery = section && section.querySelector(
    'media-gallery[data-td-offer-gallery="solo"], ' +
    'media-gallery'
  );

  if (!gallery) return;

  var indexed = indexMedia(gallery);

  var useDefaultGallery =
    selectedColor === INITIAL_DEFAULT_GALLERY;

  var defaultMediaIds =
    getDefaultGalleryMediaIds(sectionId);

  function shouldShow(group, mediaId) {
    if (useDefaultGallery) {
      return (
        !group &&
        defaultMediaIds.has(String(mediaId))
      );
    }

    return (
      group === selectedColor ||
      group === 'shared'
    );
  }

  var visibleSlides = indexed.slides.filter(
    function (slide) {
      var mediaId = extractMediaId(
        slide.dataset.mediaId
      );

      var group =
        indexed.groupsByMediaId.get(mediaId) || '';

      return shouldShow(group, mediaId);
    }
  );

  if (!visibleSlides.length) {
    if (!useDefaultGallery) {
      console.warn(
        '[TD Funda Gallery] No hay imágenes etiquetadas para:',
        selectedColor
      );
    }

    return;
  }

  indexed.slides.forEach(function (slide) {
    var mediaId = extractMediaId(
      slide.dataset.mediaId
    );

    var group =
      indexed.groupsByMediaId.get(mediaId) || '';

    setVisible(
      slide,
      shouldShow(group, mediaId)
    );
  });

  indexed.thumbs.forEach(function (thumb) {
    var mediaId = extractMediaId(
      thumb.dataset.target
    );

    var group =
      indexed.groupsByMediaId.get(mediaId) || '';

    setVisible(
      thumb,
      shouldShow(group, mediaId)
    );
  });

  var firstSlide;

  if (useDefaultGallery) {
    firstSlide = visibleSlides[0];
  } else {
    firstSlide =
      visibleSlides.find(function (slide) {
        var mediaId = extractMediaId(
          slide.dataset.mediaId
        );

        return (
          indexed.groupsByMediaId.get(mediaId) ===
          selectedColor
        );
      }) || visibleSlides[0];
  }

  if (typeof gallery.setActiveMedia === 'function') {
    gallery.setActiveMedia(
      firstSlide.dataset.mediaId,
      false
    );
  } else {
    indexed.slides.forEach(function (slide) {
      slide.classList.toggle(
        'is-active',
        slide === firstSlide
      );
    });
  }

  if (
    typeof gallery.updateActiveThumbnailVisibility ===
    'function'
  ) {
    var firstThumb = indexed.thumbs.find(
      function (thumb) {
        return (
          thumb.dataset.target ===
          firstSlide.dataset.mediaId
        );
      }
    );

    gallery.updateActiveThumbnailVisibility(
      firstThumb || null
    );
  }

  section.dataset.tdFundaSelectedColor =
    selectedColor;

  filterModal(
    sectionId,
    indexed.groupsByMediaId,
    selectedColor
  );

  window.requestAnimationFrame(function () {
    refreshSliders(
      gallery,
      visibleSlides.length
    );
  });
}

function applyInitialColor(root) {
 if (!isSupportedProductRoot(root)) return;

  var sectionId = root.dataset.sectionId;
  if (!sectionId) return;

  // Al cargar, conserva la galería predeterminada:
  // muestra solamente imágenes que no tienen [td-color:...].
  applyColor(
    sectionId,
    INITIAL_DEFAULT_GALLERY,
    PRODUCT_HANDLE
  );
}
  document.addEventListener(
    'click',
    function (event) {
      if (
        !event.target ||
        typeof event.target.closest !== 'function'
      ) {
        return;
      }

      var button = event.target.closest(
        '[data-td-funda-base-color]'
      );

      if (!button) return;

      var root = button.closest(
        '[data-td-funda-builder]'
      );

if (!isSupportedProductRoot(root)) {
  return;
}

      var sectionId = root.dataset.sectionId;

      var color = button.getAttribute(
        'data-td-funda-base-color'
      );

      window.requestAnimationFrame(function () {
        applyColor(
          sectionId,
          color,
          PRODUCT_HANDLE
        );
      });
    },
    true
  );

  document.addEventListener(
    'td:product-modal-built',
    function (event) {
      var detail = event.detail || {};
      var section = getSection(detail.sectionId);

      var color =
        section &&
        section.dataset.tdFundaSelectedColor;

      if (color) {
        window.requestAnimationFrame(function () {
          applyColor(
            detail.sectionId,
            color,
            PRODUCT_HANDLE
          );
        });
      }
    }
  );

  function init() {
    document
      .querySelectorAll(
        '[data-td-funda-builder]'
      )
      .forEach(function (root) {
        applyInitialColor(root);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    init
  );
})();